import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './componentes/layout';
import { useApp } from './estado';
import { Auditoria } from './paginas/auditoria';
import { Configuracoes } from './paginas/configuracoes';
import { Disparos } from './paginas/disparos';
import { Eventos } from './paginas/eventos';
import { Login } from './paginas/login';
import { Receitas } from './paginas/receitas';
import { Templates } from './paginas/templates';
import { VisaoGeral } from './paginas/visao-geral';
import { Provisionamento } from './paginas/provisionamento';

export function App() {
  const { carregando, usuario, marca } = useApp();
  const local = useLocation();

  if (local.pathname === '/interno') return <Provisionamento />;

  if (carregando) {
    return (
      <div className="splash" role="status" aria-live="polite">
        <div className="splash__caixa">
          <img className="splash__logo" src="/logo.svg" alt="" width={56} height={56} />
          <strong>{marca?.branding.nomeExibicao ?? 'Disparos'}</strong>
          <span className="texto-pequeno">Carregando o motor…</span>
        </div>
      </div>
    );
  }

  if (!usuario) return <Login />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<VisaoGeral />} />
        <Route path="receitas" element={<Receitas />} />
        <Route path="templates" element={<Templates />} />
        <Route path="disparos" element={<Disparos />} />
        <Route path="eventos" element={<Eventos />} />
        <Route path="configuracoes" element={<Configuracoes />} />
        <Route path="auditoria" element={<Auditoria />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
